import _ from 'lodash'
import { EntityState } from '@reduxjs/toolkit'
import { CommonState, Model } from '../classes/Model'

export type Device = {
  deviceId: string
  name: string
  type: MediaDeviceKind
}

export type CustomDevice = {
  _id: string
  device: Device
  customName: string
  owner: string | Record<string, any> // TODO: depend on the fact that owner is populated or not in order to specify object type
  iconURL: string
  type: string
  ptz: boolean
}

export type CreateCustomDeviceDto = Omit<CustomDevice, '_id' | 'owner'> & {
  owner: string
}

export type CustomDeviceState = CommonState & {
  customDevices: EntityState<CustomDevice & { available?: boolean }, CustomDevice['_id']>
}

class CustomDeviceModel extends Model {
  static instance: CustomDeviceModel

  static getInstance() {
    if (!CustomDeviceModel.instance) {
      CustomDeviceModel.instance = new CustomDeviceModel('customDevice')
    }
    return CustomDeviceModel.instance
  }

  getInitialState(): CustomDeviceState {
    return _.merge({}, this.commonState, {
      customDevices: {
        entities: {},
        ids: [],
      },
    })
  }

  getCustomDevices = async (): Promise<CustomDevice[]> => {
    return await this.httpClient.request<CustomDevice[]>('/custom-devices', 'GET')
  }

  createCustomDevice = async (createCustomDeviceDto: CreateCustomDeviceDto): Promise<CustomDevice> => {
    return await this.httpClient.request<CustomDevice>('/custom-devices', 'POST', createCustomDeviceDto)
  }

  deleteCustomDevice = async (id: string) => {
    await this.httpClient.request(`/custom-devices/${id}`, 'DELETE')
  }
}

export default CustomDeviceModel.getInstance()
